import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function DocToTemplateBtn(props) {
  return (
    <li>
      <div
        data-test="save-template-as-doc-btn"
        className="send-list-item"
        role="button"
        tabIndex="0"
        onClick={() => props.togglePopup()}
        onKeyPress={() => {}}>
        <div className="btn-send-icon">
          <FontAwesomeIcon
            icon={["far", "save"]}
            className="documentrecipientlist-role-icon"
          />
        </div>
        <div>
          <div className="btn-send-heading">
            {" "}
            Save as template
            <span className="save-doc-temp-new-tag">New</span>
          </div>
          <div className="btn-send-desc">
            Save this document as a reusable template
          </div>
        </div>
      </div>
    </li>
  );
}



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV2/QuotationTopBarBtns/DocToTemplate/DocToTemplateBtn.js